import { BuiTooltip } from '@breuni-ui/tooltip';
import { safeDefine } from '@breuni-ui/safe-define';

// empty by intention
class EntsTooltip extends BuiTooltip {
}

safeDefine('ents-tooltip', EntsTooltip);
